import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useAPIEditCustomerDiscount } from "../api/api-edit-customer-discount";
import {
  genElText,
  genElObject,
  genElDate,
  genElNumber,
  genElBoolean,
  genElTextDropdown,
  genElTextArea,
} from "../../../../components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import CustomerSelectorMain from "../../../selectors/customer-selector/component/customer-selector-main";
import { useSelector } from "react-redux";

// PART_IMPORT_SELECTOR_DIALOG

const CustomerDiscountEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;
  const employee = useSelector((state) => state.auth.employee);

  const {
    loading,
    data,
    setData,
    fetchDataOrCreateNew,
    error,
    setError,
    handleOnConfirm,
  } = useAPIEditCustomerDiscount({ onConfirmed });

  // PART_DIALOG_STATE
  const [showCustomerSelector, setShowCustomerSelector] = useState(false);

  // use effect section

  useEffect(() => {
    if (visible) {
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
    if (onHide) {
      setError({});
    }
  }, [visible]);

  // handle ui event section

  // genereate editor element section

  // PART_HANDLE_SELECTOR

  const handleOnClickCustomer = () => {
    setShowCustomerSelector(true);
  };

  const handleOnConfirmCustomer = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({ ...data, data_customer: selected, customer_id: selected.id });
      setShowCustomerSelector(false);
    }
    return selected;
  };

  // PART_FIELDS_GENERATOR

  const elCustomer = genElObject({
    field: 'customer_id',
    name: 'Customer',
    value: data.data_customer ? data.data_customer.name : '',
    onClick: handleOnClickCustomer,
    error,
  });

  const elExpiredDate = genElDate({
    field: 'expired_date',
    name: 'Expired Date',
    data,
    setData,
    error,
  });

  const elDiscount = genElText({
    field: 'name',
    name: 'Discount Name',
    data,
    setData,
    error,
  });

  const elValue = genElNumber({
    field: 'value',
    name: 'Value',
    data,
    setData,
    error,
  });

  const elType = genElTextDropdown({
    field: 'type',
    name: 'Type',
    data,
    setData,
    error,
    placeholder: 'Select Type',
    options: [
      { name: 'Amount', value: 1 },
      { name: 'Percentage', value: 2 },
    ],
  });

  const elDescription = genElTextArea({
    field: 'description',
    name: 'Description',
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "35rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={data.id && data.id > 0 ? "Edit Request" : "Add Request"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      {/* PART_SELECTOR_DIALOG */}

      <CustomerSelectorMain
        title={'Select Customer'}
        visible={showCustomerSelector}
        onHide={() => setShowCustomerSelector(false)}
        onConfirm={handleOnConfirmCustomer}
        additionalFilter={employee?.user_type == 3 ? `bc_id:=:${employee.id}` : ''}
      />

      <div className="col-start-center relative h-100 gap-3">
        {/* PART_FIELDS_RENDER */}
        {elCustomer}
        <div className="row-start-start w-full gap-2">
          {elDiscount}
          {elExpiredDate}
        </div>
        {elValue}
        {elType}
        {elDescription}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default CustomerDiscountEdit;
